export const deepCopy2DArray = <T>(arr: T[][]) => {
  const copy: T[][] = [];
  for (let i = 0; i < arr.length; i++) {
    const row = [...arr[i]];
    copy.push(row);
  }
  return copy;
};
